import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { pinComment } from '../../../api/comments';

import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeCommentWithUserData } from '../../../utils/comments';

export const pinnComment = createAsyncThunk(
  'comments/pinnComment',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentResponse, commentUserDaraResponse] = await pinComment(
        commentData,
        {
          cancelToken: source.token,
        },
      );
      return mergeCommentWithUserData(commentResponse, commentUserDaraResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const pinnCommentExtraReducers = builder => {
  builder
    .addCase(pinnComment.pending, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);
      checkAndSetLoadingWithId(
        state.comments.comment.actions.pinn.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(pinnComment.fulfilled, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);
      onMatchedRequest(
        state.comments.comment.actions.pinn.request[commentCIDKey],
        action,
        () => {
          state.comments.comment.byId[commentCIDKey] = action.payload;
          if (!state.comments.comment.allIds.includes(commentCIDKey)) {
            state.comments.comment.allIds.push(commentCIDKey);
          }
        },
      );
    })
    .addCase(pinnComment.rejected, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);
      handleRequestRejection(
        state.comments.comment.actions.pinn.request[commentCIDKey],
        action,
      );
    });
};
